import { useSelector } from "react-redux";
import {
  selectIsCompanyMember,
  selectIsCompanyOwner,
  selectIsCompanyOwnerOrManager,
} from "../redux/selectors";

const useLoginRole = () => {
  const isCompanyMember = useSelector(selectIsCompanyMember);
  const isCompanyOwner = useSelector(selectIsCompanyOwner);
  const isCompanyOwnerOrManager = useSelector(selectIsCompanyOwnerOrManager);

  return {
    isCompanyMember,
    isCompanyOwner,
    isCompanyOwnerOrManager,
  };
};

export default useLoginRole;
